import { render, staticRenderFns } from "./PricelistDetail.vue?vue&type=template&id=058e5e96&scoped=true"
import script from "./PricelistDetail.vue?vue&type=script&lang=js"
export * from "./PricelistDetail.vue?vue&type=script&lang=js"
import style0 from "./PricelistDetail.vue?vue&type=style&index=0&id=058e5e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e5e96",
  null
  
)

export default component.exports